import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';
import ReportDetailsTable from '../ReportDetailsTable';
import csvDownloader from '../../utils/csvDownloader';
import * as quotaSelectors from '../../selectors/quota';
import Loading from '../Loading';
import Error from '../Error';

const ReportDetailsTab = ({
  selector,
  headers,
  columns,
  records,
  activePage,
  paginate,
  filter,
  filtering,
  csvFilename,
  csvDescription,
  csvColumns,
  noRecordsMessage,
  dataLimitExceeded, 
  loading,
  error,
  contactSupport,
  onDownloadCSVClick
}) => {

  // todo: fix this linter error
  /* eslint-disable import/namespace */
  const selectedRecords = selector
    ? quotaSelectors[selector](records)
    : records;
  /* eslint-enable import/namespace */

  return (
    <div>
      <p className="report-details-csv">
        <span>
          {csvDescription}
        </span>
        <a
          href="#"
          onClick={
            csvDownloader(
              selectedRecords,
              csvFilename,
              filtering,
              csvColumns,
              Object.keys(csvColumns),
              onDownloadCSVClick
            )
          }
        >
          Download CSV <i className="icon-budicon-355" />
        </a>
      </p>
      {dataLimitExceeded && 
        <Alert variant="warning">
          {'You’ve reached the maximum amount of results allowed. '}
          {contactSupport || 'Contact Support'}
          {' to enable your full report data.'}
        </Alert>
      }
      <Loading show={loading}>
        <Error message={error}>
          <ReportDetailsTable
          records={selectedRecords}
          paginate={paginate}
          activePage={activePage}
          filter={filter}
          filtering={filtering}
          headers={headers}
          columns={columns}
          noRecordsMessage={noRecordsMessage}
        />
        </Error>
      </Loading>
    </div>
  );
};

ReportDetailsTab.propTypes = {
  selector: PropTypes.string,
  headers: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  paginate: PropTypes.func.isRequired,
  activePage: PropTypes.number.isRequired,
  filtering: PropTypes.object.isRequired,
  filter: PropTypes.func.isRequired,
  csvFilename: PropTypes.string.isRequired,
  csvDescription: PropTypes.string.isRequired,
  records: PropTypes.array,
  csvColumns: PropTypes.object,
  noRecordsMessage: PropTypes.string,
  dataLimitExceeded: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.string,
  contactSupport: PropTypes.element,
  onDownloadCSVClick: PropTypes.func,
};

export default ReportDetailsTab;
